module.exports = __webpack_public_path__ + "static/media/phoneIcon.9e23befb.svg";